import { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/common/PageHero";
import { IMAGES } from "@/data/site";
import { api } from "@/lib/api";

const CATEGORIES = [
  { key: "", label: "Todas" },
  { key: "jogadores", label: "Jogadores" },
  { key: "scouting", label: "Scouting" },
  { key: "transferencias", label: "Transferências" },
  { key: "conquistas", label: "Conquistas" },
  { key: "convocatorias", label: "Convocatórias" },
  { key: "parcerias", label: "Parcerias" },
  { key: "carreira", label: "Carreira" },
  { key: "formacao", label: "Formação" },
  { key: "agencia", label: "Agência" },
];

export default function News() {
  const [news, setNews] = useState([]);
  const [cat, setCat] = useState("");

  useEffect(() => {
    api.get("/news", { params: { limit: 50 } }).then((r) => setNews(r.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtered = useMemo(() => cat ? news.filter((n) => n.category === cat) : news, [news, cat]);

  return (
    <>
      <PageHero
        eyebrow="Notícias"
        title={<>Legacy <span className="text-[#A67C00]">News</span></>}
        subtitle="Novidades, atualizações e atividade da AF Legacy Sports."
        image={IMAGES.training}
      />

      <section className="py-12 border-b border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-wrap gap-3">
          {CATEGORIES.map((c) => (
            <button
              key={c.key || "all"}
              data-testid={`news-cat-${c.key || "all"}`}
              onClick={() => setCat(c.key)}
              className={`px-4 py-2 text-[0.7rem] tracking-[0.2em] uppercase border transition-colors ${
                cat === c.key ? "bg-[#A67C00] border-[#A67C00] text-white" : "border-white/10 text-neutral-300 hover:border-[#A67C00] hover:text-[#A67C00]"
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>
      </section>

      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          {filtered.length === 0 ? (
            <div className="text-center text-neutral-500 py-16">Sem notícias nesta categoria.</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filtered.map((n) => (
                <Link
                  key={n.slug}
                  to={`/legacy-news/${n.slug}`}
                  data-testid={`news-item-${n.slug}`}
                  className="group"
                >
                  <div className="relative aspect-[4/3] overflow-hidden zoom-parent mb-6">
                    <img src={n.image} alt={n.title} className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute top-4 left-4 bg-[#A67C00] px-3 py-1 text-white text-[0.6rem] tracking-[0.3em] uppercase">
                      {n.category}
                    </div>
                  </div>
                  <div className="text-neutral-500 text-xs tracking-[0.25em] uppercase mb-3">
                    {new Date(n.date).toLocaleDateString("pt-PT", { day: "2-digit", month: "long", year: "numeric" })}
                  </div>
                  <h3 className="font-cinzel uppercase text-white text-xl leading-tight mb-3 group-hover:text-[#A67C00] transition-colors">
                    {n.title}
                  </h3>
                  <p className="text-neutral-400 text-sm leading-relaxed line-clamp-3 mb-4">{n.summary}</p>
                  <div className="text-[#A67C00] text-xs tracking-[0.25em] uppercase inline-flex items-center gap-2 group-hover:gap-4 transition-all">
                    Ler mais <ArrowRight size={12} />
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
